import { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import get from 'lodash/get';
import Divider from '../../shared/Divider';
import CollapsibleLabel from '../../shared/CollapsibleLabel';
import withCollapsibleState from '../../../decorators/withCollapsibleState';
import {
  SEE_LESS,
  SEE_MORE,
} from '../../../constants/localizations/containerItems';
import containerItemsCss from '../container-items.module.scss';
import sharedCss from '../shared/shared-card.module.scss';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import css from './schedule-card.module.scss';
import ScheduleItem from './childPresentations/ScheduleItem';

// exported for testing
export const ScheduleCard = ({
  containerItem,
  id,
  shouldShowMore,
  handleMoreClick,
}) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const children = get(containerItem, 'children', []);
  const shouldShowMoreButton = children.length > 5;
  const numChildrenToRender = shouldShowMore ? 12 : 5;
  const childrenToRender = children.slice(0, numChildrenToRender);

  return (
    <div
      className={classnames(
        containerItemsCss.containerItem,
        css.scheduleCardContainer,
      )}
      id={id}
      data-testid={id}
      data-testtype="scheduleCard"
      data-testcount={childrenToRender ? childrenToRender.length : 0}
    >
      <div data-testid="containerGuideItemsContainer">
        {childrenToRender.map((child, i) => (
          <Fragment key={`scheduleItem-${i}`}>
            <ScheduleItem guideItem={child} index={i} />
            {(i !== childrenToRender.length - 1 || shouldShowMoreButton) && (
              <Divider className={css.divider} />
            )}
          </Fragment>
        ))}
        {shouldShowMoreButton && (
          <CollapsibleLabel
            onMoreInfoClick={handleMoreClick}
            shouldShowMore={shouldShowMore}
            moreText={getLocalizedText(SEE_MORE)}
            lessText={getLocalizedText(SEE_LESS)}
            className={classnames(
              sharedCss.collapsibleLabel,
              css.collapsibleLabel,
            )}
            caretClassName={sharedCss.caret}
          />
        )}
      </div>
    </div>
  );
};

ScheduleCard.propTypes = {
  containerItem: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  shouldShowMore: PropTypes.bool.isRequired,
  handleMoreClick: PropTypes.func.isRequired,
};

export default withCollapsibleState(ScheduleCard);
